import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgChartsModule } from 'ng2-charts';

@Component({
  standalone: true,
  selector: 'app-doughnut-chart',
  templateUrl: 'doughnut-chart.component.html',
  styleUrls: ['doughnut-chart.component.scss'],
  imports: [CommonModule, NgChartsModule],
})
export class DoughnutChartComponent implements OnChanges {
  @Input() chartData: any;
  @Input() chartCenterText: number = 0;

  chartVisible: boolean = true;

  chartOptions: any = {
    responsive: false,
    maintainAspectRatio: false,
    cutout: '70%',
    plugins: {
      legend: { display: false },
      title: { display: true, text: '', font: { size: 18, weight: 'bold' }, color: '#333' },
      tooltip: { enabled: true },
    },
  };

  public doughnutColors: any[] = [
    { backgroundColor: ['#bad424', '#E15759'], hoverBackgroundColor: ['#bad424', '#E15759'] },
  ];

  ngOnChanges(changes: SimpleChanges): void {
    if (this.chartData) {
      if (this.chartData.title) {
        this.chartOptions.plugins.title.text = this.chartData.title;
      }
      this.updateChartCenterText();
    }

    if (changes['chartData'] && !changes['chartData'].isFirstChange()) {
      this.forceRedraw();
    }
  }

  private updateChartCenterText(): void {
    let ds: any[] = null;
    if (this.chartData && this.chartData.datasets && this.chartData.datasets.length > 0) {
      const first = this.chartData.datasets[0];
      if (first && first.data && first.data.length >= 2) {
        ds = first.data;
      }
    }

    if (ds) {
      const total = ds.reduce((a: number, v: number) => a + (v || 0), 0);
      this.chartCenterText = total > 0 ? Math.round((ds[0] / total) * 100) : 0;
    } else {
      this.chartCenterText = 0;
    }
  }

  private forceRedraw(): void {
    this.chartVisible = false; // destroy <base-chart>
    setTimeout(() => {
      this.chartVisible = true;
    }, 0); // recreate
  }
}
